import { render, staticRenderFns } from "./AdherenceIndicatorsFooterGDI.vue?vue&type=template&id=410c2709&scoped=true&"
import script from "./AdherenceIndicatorsFooterGDI.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsFooterGDI.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsFooterGDI.vue?vue&type=style&index=0&id=410c2709&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410c2709",
  null
  
)

export default component.exports